import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component GitPullRequestClosedIcon
 * @description
 * Outline git pull-request glyph for a closed (unmerged) pull request.
 * The left branch matches GitPullRequestIcon (two nodes and a connecting line).
 * On the right, the incoming branch is shown as two evenly spaced dots leading
 * up to an X node, signifying that the pull request was closed without merging.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string applied to the stroke.
 *
 * @see https://design.activecollab.com/docs/foundations/icons
 */
const GitPullRequestClosedIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="GitPullRequestClosedIcon"
      fill="none"
      stroke={
        gradient
          ? "url(#icon-gradient)"
          : props?.stroke
          ? props.stroke
          : "var(--color-theme-600)"
      }
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path d="M7 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
      <path d="M7 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
      <path d="M7 8v8" />
      <path d="M17 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
      <path d="M17 13.5v0" />
      <path d="M17 10.5v0" />
      <path d="M15 4l4 4" />
      <path d="M19 4l-4 4" />
    </svg>
  )
);
GitPullRequestClosedIcon.displayName = "GitPullRequestClosedIcon";
export default GitPullRequestClosedIcon;
